import { Interpolation } from "@emotion/core";
import { Fonts } from "../../../../design-tokens/fonts";
import { Device, DarkTheme } from "../../../../design-tokens/media-queries";
import { Colors } from "../../../../design-tokens/colors";
import { grid } from "../../../../design-tokens/grid";

const headingContainer: Interpolation = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: grid(-1),

  [Device.DesktopTablet]: {
    marginRight: grid(1),
  },
};

const heading: Interpolation = {
  fontSize: "18px",
  lineHeight: "24px",
  fontWeight: Fonts.Weight.Bold,
  color: Colors.Black,

  [DarkTheme]: {
    color: Colors.DarkModeWhite,
  },

  [Device.DesktopTablet]: {
    fontSize: "22px",
    lineHeight: "30px",
  },
};

const infoContainer: Interpolation = {
  display: "flex",
  justifyContent: "space-between",
};

const description: Interpolation = {
  fontSize: "12px",
  lineHeight: "16px",
  textAlign: "right",
  color: Colors.MidGrey,
  maxWidth: grid(9.5),
  marginRight: grid(1),

  [DarkTheme]: {
    color: Colors.LightGrey,
  },
};

const value: Interpolation = {
  fontSize: "37px",
  lineHeight: 1,
  fontWeight: Fonts.Weight.Bold,
};

const styles = {
  headingContainer,
  heading,
  infoContainer,
  description,
  value,
};

export default styles;
